import { styled } from '@linaria/react';
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { Button, TextLink, VidbaseIcon, Wordmark, HamburgerButton } from '@vidbaseapp/styleguide';
import { motion, AnimatePresence } from 'framer-motion';
import { HeaderNav } from './components/HeaderNav';
import { spring } from './sections/LandingSplash';
export const StyledLandingHeader = /*#__PURE__*/styled("header")({
  name: "StyledLandingHeader",
  class: "skj5tf0"
});
export const mobileMenuVariants = {
  hidden: {
    opacity: 0,
    x: 150
  },
  visible: {
    opacity: 1,
    x: 0
  },
  exit: {
    opacity: 0,
    x: 150
  }
};
const FullMenuData = [{
  name: t => 'Use Cases',
  children: [{
    icon: () => '🎙️',
    href: '/use-cases/podcasts',
    label: t => 'Podcasters',
    desc: t => 'Audio-only podcasts, interviews, and chats.'
  }, {
    icon: () => '📺',
    href: '/use-cases/youtube',
    label: t => 'YouTubers',
    desc: t => 'Video essays, talking heads, tutorials, etc.'
  }, {
    icon: () => '💸',
    href: '/use-cases/marketing',
    label: t => 'Marketers',
    desc: t => 'Video advertisements, real-estate, etc.'
  }, {
    icon: () => '📸',
    href: '/use-cases/photography',
    label: t => 'Photographers',
    desc: t => 'Landscapes, portraits, street, product, etc.'
  }, {
    icon: () => '🎥',
    href: '/use-cases/videography',
    label: t => 'Videographers',
    desc: t => 'Wedding videos, music videos, promotional, etc.'
  }]
}, {
  name: t => 'How it Works',
  children: [{
    icon: () => '⚡',
    href: '/features/ui',
    label: t => 'Lightning Fast UI',
    desc: t => 'High performance, from the ground up.'
  }, {
    icon: () => '🧠',
    href: '/features/ml',
    label: t => 'ML-powered Automation',
    desc: t => 'Skip all of the busywork.'
  }, {
    icon: () => '💏',
    href: '/features/collab',
    label: t => 'Collaboration',
    desc: t => 'Work together in real-time.'
  }]
}, {
  name: t => 'Pricing',
  href: '/pricing'
}, {
  name: t => 'Company',
  href: '/about'
}];
export const LandingHeader = ({
  session,
  ...props
}) => {
  const {
    t
  } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollYPos, setScrollYPos] = useState(0);
  const [MobileMenu, setMobileMenu] = useState([]);

  const handleScroll = () => {
    setScrollYPos(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    setMobileMenu(() => {
      return FullMenuData.map(d => {
        return <div className="m-menu-section" key={`m-menu-${d.name}`}>
						<a className="m-menu-section-heading" href={d.href || '#'}>
							<h2>{d.name(t)}</h2>
						</a>
						<ul>
							{(d.children || []).map((row, index) => {
              return <li key={`m-menu-row-${d.name}-${index}`}>
										<a href={row.href}>{row.label(t)}</a>
									</li>;
            })}
						</ul>
					</div>;
      });
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isLoggedIn = !!session?.user?.id || false;
  return <StyledLandingHeader {...props} className={clsx(props.className || '', {
    sticky: scrollYPos !== 0
  })}>
			<div className="headerContent">
				<a href="/" className="goHome" title={t('landing:dashboard')} draggable={false}>
					<VidbaseIcon size="44px" color={'var(--clr-blue)'} enableFilters={false} />
					<Wordmark height="1rem" fill={'var(--clr-white)'} enableFilters={false} />
				</a>
				<HeaderNav className="desktop-up"></HeaderNav>
				<div className="actions desktop-up">
					<TextLink href="https://edit.vidbase.app/" size={'var(--font-size-2sm)'} color={'var(--clr-blue)'} draggable={false}>
						{t('common:login')}
					</TextLink>
					{isLoggedIn == true ? <div className="cta-btn">
							<Button as="a" href="https://edit.vidbase.app/" size={'var(--font-size-2sm)'} draggable={false}>
								{t('landing:dashboard')}
							</Button>
						</div> : <div className="cta-btn">
							<Button as="a" href="https://vid.bs/signup" size={'var(--font-size-2sm)'} draggable={false}>
								{t('landing:requestAccess')}
							</Button>
						</div>}
				</div>
				<div className="m-actions not-desktop">
					<HamburgerButton onClick={() => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        }} />
				</div>
				<AnimatePresence>
					{isMobileMenuOpen === true ? <motion.div className="m-menu not-desktop" variants={mobileMenuVariants} initial={'hidden'} animate={'visible'} transition={spring} exit="exit">
							{MobileMenu}
						</motion.div> : null}
				</AnimatePresence>
			</div>
		</StyledLandingHeader>;
};

require("./LandingHeader.linaria.module.css!=!../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingHeader.tsx");